import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';
export const InputStyled = styled.input.attrs(({ masked }) => ({
  className: `input ${masked ? 'fs-mask' : ''}`.trim(),
}))`
  ${({ theme, error, suggestedIsActive }) => {
    const { colors, shadows } = theme;

    return css`
      background-color: ${error ? convertHexToRgba(colors.primary.red, 0.1) : colors.primary.white};
      border: 1px solid ${colors.primary.darkBlue};
      border-radius: 4px;
      color: ${colors.primary.darkBlue};
      font-size: 16px;
      font-weight: 300;
      height: 50px;
      padding: 0 15px;
      transition: box-shadow 0.2s;
      width: 100%;

      &:focus {
        box-shadow: 0 0 2px 2px ${colors.borders.focus};
        outline: none;
      }

      ${error && `border: 1px solid ${colors.primary.red};`};
      ${suggestedIsActive &&
      `border-bottom-right-radius: 0px;
         border-bottom-left-radius: 0px;
         box-shadow: ${shadows.default};
         transition: box-shadow 100ms;
        `};

      &::placeholder {
        color: ${colors.primary.lightgray};
        font-size: 24px;
        opacity: 0.5;
      }

      &:focus {
        outline-color: ${colors.borders.focus} auto 5px;
        outline-offset: -2px;
      }

      &:disabled {
        color: ${colors.borders.focus};
        border-color: ${colors.borders.focus};

        &::placeholder {
          color: ${colors.borders.focus};
        }
      }
    `;
  }};
`;

export const CheckboxStyled = styled.div.attrs(() => ({
  className: 'checkbox',
}))`
  ${({ theme }) => {
    const { colors } = theme;

    return css`
      display: inline-block;
      height: 25px;
      position: relative;
      margin-right: 10px;
      width: 25px;
      flex: 0 0 25px;

      input {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        height: 25px;
        width: 25px;
        padding: 0;
        margin: 0;
        z-index: 1;

        &:disabled {
          cursor: not-allowed;
        }

        &:disabled + span {
          border-color: ${colors.primary.darkBlue};
        }

        &:checked + span {
          background-color: ${colors.primary.white};
          border-color: ${colors.primary.darkBlue};

          svg {
            opacity: 1;
            color: ${colors.primary.red};
          }
        }

        &:focus + span {
          box-shadow: 0 0 2px 2px rgba(0, 103, 244, 0.5);
          outline-offset: -2px;
        }
      }

      span {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        height: 25px;
        width: 25px;
        padding: 3px;
        border-style: solid;
        border-width: 1px;
        border-color: ${colors.primary.darkBlue};
        transition: all 0.2s;
      }

      svg {
        color: ${colors.primary.red};
        cursor: pointer;
        opacity: 0;
        fill: ${colors.primary.red};
        transform: scale(1.5) translate(4px, -2px);
      }
    `;
  }};
`;

export const RadioStyled = styled.div.attrs(() => ({
  className: 'radio',
}))`
  ${({ theme }) => {
    const { colors } = theme;
    return css`
      display: inline-block;
      height: 16px;
      margin-right: 6px;
      position: relative;
      width: 16px;

      input {
        cursor: pointer;
        position: absolute;
        top: 0px;
        left: 0px;
        opacity: 0;
        height: inherit;
        width: inherit;
        padding: 0px;
        margin: 0px;
        z-index: 1;
      }

      span {
        background-color: ${colors.primary.white};
        border: 1px solid ${colors.secondary.darkBlue};
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: inherit;
        width: inherit;
        padding: 3px;
        border-radius: 100%;
        transition: all 0.1s;

        &::before {
          position: absolute;
          display: inline-block;
          content: '';
          height: 16px;
          width: 16px;
          border-radius: 100%;
          opacity: 0;
          transform: scale(0.8);
          transform-origin: center center;
          background-color: ${colors.primary.white};
          transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1) 0s;
        }
      }

      input:checked + span {
        background-color: ${colors.primary.white};
        border: 1px solid ${colors.secondary.gray};

        &::before {
          background-color: ${colors.primary.red};
          border: 2px solid ${colors.primary.white};
          box-shadow: 0px 0px 0px 1px ${colors.primary.gray};
          opacity: 1;
          transform: scale(1);
          top: 0px;
          left: 0px;
        }
      }
    `;
  }}
`;
